<div fxLayout>
  <main fxFlex style="padding: 0px; margin-bottom: 0">
    <picture>
      <source srcset="assets/images/demo/metrics/metrics.webp" type="image/webp" />
      <img src="assets/images/demo/metrics/metrics.svg" class="demo-ux-image" (load)="isImageLoaded = true" />
    </picture>

    <div class="demo-callout rules__intro-text" *ngIf="isImageLoaded">
      <ng-container *ngIf="metricsEntitlements$ | async as entitlements; else loadingTemplate">
        <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
          <h2>Grow your business with insightful data.</h2>
          <p class="notification__description">
            Hospitable Metrics can be the single source of truth for your Reservations, Taxes, Reviews, and Tasks data.
            See the health of your properties for the selected time frame and see how they compare to the last period.
            Export the data and analyze it further into a platform of your choice.
          </p>

          <ng-container [ngSwitch]="entitlements.available">
            <p *ngSwitchCase="true" class="notification__description">
              Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import your listings into
              your Hospitable.com account and start using metrics today!
            </p>
            <p *ngSwitchCase="false" class="notification__description">
              Upgrade your account to start using metrics today!
            </p>
          </ng-container>

          <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="4px">
            <ng-container [ngSwitch]="entitlements.available">
              <sbnb-button
                *ngSwitchCase="true"
                (clicked)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
                Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
              </sbnb-button>

              <sbnb-button *ngSwitchCase="false" (clicked)="clickedUpgradeCta()">Upgrade for access</sbnb-button>
            </ng-container>

            <sbnb-button
              type="secondary"
              (clicked)="clickedSecondaryCta('https://help.hospitable.com/en/articles/8793124-metrics-walkthrough')">
              Learn more
            </sbnb-button>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #loadingTemplate>
        <sbnb-loading-spinner></sbnb-loading-spinner>
      </ng-template>
    </div>
  </main>
</div>
